import React from 'react';

const BusinessTransportProcessSection = () => {
  return (
    <section className="business-process-section">
      <h2 className="business-process-title">운송 프로세스</h2>
      <div className="business-process-flow">
        <div className="business-process-step">
          <div className="business-process-number">01</div>
          <div className="business-process-step-content">
            <h3 className="business-process-step-title">공고 확인</h3>
            <p className="business-process-step-desc">운송 의뢰 공고를 확인하고 운송 정보를 파악합니다.</p>
          </div>
        </div>
        <div className="business-process-step">
          <div className="business-process-number">02</div>
          <div className="business-process-step-content">
            <h3 className="business-process-step-title">면접 및 상담</h3>
            <p className="business-process-step-desc">운송기사 면접을 진행하고 운송 조건을 상담합니다.</p>
          </div>
        </div>
        <div className="business-process-step">
          <div className="business-process-number">03</div>
          <div className="business-process-step-content">
            <h3 className="business-process-step-title">계약서 작성</h3>
            <p className="business-process-step-desc">운송 계약서를 작성하고 계약을 체결합니다.</p>
          </div>
        </div>
        <div className="business-process-step">
          <div className="business-process-number">04</div>
          <div className="business-process-step-content">
            <h3 className="business-process-step-title">인수인계</h3>
            <p className="business-process-step-desc">전 코스 운송기사와의 인수인계 절차를 진행합니다.</p>
          </div>
        </div>
        <div className="business-process-step">
          <div className="business-process-number">05</div>
          <div className="business-process-step-content">
            <h3 className="business-process-step-title">배송 시작</h3>
            <p className="business-process-step-desc">계약 체결 후 바로 배송을 시작합니다.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessTransportProcessSection;

